// @ts-nocheck
(function () {
  if (!window.customElements) return;
  if (customElements.get('quantity-selector')) return;

  var VARIANT_CHANGE_EVENT = 'product:variant-change';

  class QuantitySelectorElement extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this._decreaseButton = this.querySelector('[data-quantity-decrease]');
      this._increaseButton = this.querySelector('[data-quantity-increase]');
      this._valueElement = this.querySelector('[data-quantity-value]');
      this._quantityInput =
        this.querySelector('input[name="quantity"]') ||
        this._createHiddenInput();

      var parsedMin = parseInt(this.getAttribute('data-min') || '', 10);
      this._min = Number.isNaN(parsedMin) ? 1 : parsedMin;

      var parsedMax = parseInt(this.getAttribute('data-max') || '', 10);
      this._max = Number.isNaN(parsedMax) ? null : parsedMax;

      var parsedStep = parseInt(this.getAttribute('data-step') || '', 10);
      this._step = Number.isNaN(parsedStep) || parsedStep <= 0 ? 1 : parsedStep;
      this._maxErrorMessage = this.getAttribute('data-max-error-message') || '';

      this._onDecreaseClick =
        this._onDecreaseClick || this.onDecreaseClick.bind(this);
      this._onIncreaseClick =
        this._onIncreaseClick || this.onIncreaseClick.bind(this);
      this._onVariantChange =
        this._onVariantChange || this.onVariantChange.bind(this);

      if (this._decreaseButton) {
        this._decreaseButton.addEventListener('click', this._onDecreaseClick);
      }

      if (this._increaseButton) {
        this._increaseButton.addEventListener('click', this._onIncreaseClick);
      }

      document.addEventListener(VARIANT_CHANGE_EVENT, this._onVariantChange);

      this.setQuantity(this.getQuantity());
    }

    disconnectedCallback() {
      if (this._decreaseButton && this._onDecreaseClick) {
        this._decreaseButton.removeEventListener(
          'click',
          this._onDecreaseClick
        );
      }

      if (this._increaseButton && this._onIncreaseClick) {
        this._increaseButton.removeEventListener(
          'click',
          this._onIncreaseClick
        );
      }

      if (this._onVariantChange) {
        document.removeEventListener(
          VARIANT_CHANGE_EVENT,
          this._onVariantChange
        );
      }
    }

    _createHiddenInput() {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = '1';
      this.appendChild(input);
      return input;
    }

    getQuantity() {
      if (!(this._quantityInput instanceof HTMLInputElement)) {
        return this._min;
      }

      var parsedQuantity = parseInt(this._quantityInput.value || '', 10);
      if (Number.isNaN(parsedQuantity)) {
        return this._min;
      }

      return parsedQuantity;
    }

    isSameProductScope(event) {
      if (!event || !event.detail) {
        return false;
      }

      var productId = this.getAttribute('data-product-id');
      if (!productId || String(productId) !== String(event.detail.productId)) {
        return false;
      }

      if (!(event.target instanceof Element)) {
        return true;
      }

      var currentForm = this.closest('form');
      var sourceForm = event.target.closest('form');
      if (currentForm && sourceForm) {
        return currentForm === sourceForm;
      }

      return true;
    }

    onVariantChange(event) {
      if (!this.isSameProductScope(event)) {
        return;
      }

      this.setMax(event.detail.quantityMax, event.detail.quantityMaxMessage);
    }

    setMax(nextMax, nextMaxErrorMessage) {
      if (nextMax == null || nextMax === '') {
        this._max = null;
        this.removeAttribute('data-max');
        this._maxErrorMessage = '';
        this.removeAttribute('data-max-error-message');
      } else {
        var parsedMax = parseInt(nextMax, 10);
        if (Number.isNaN(parsedMax)) {
          this._max = null;
          this.removeAttribute('data-max');
          this._maxErrorMessage = '';
          this.removeAttribute('data-max-error-message');
        } else {
          this._max = Math.max(this._min, parsedMax);
          this.setAttribute('data-max', String(this._max));
          this._maxErrorMessage = nextMaxErrorMessage || '';
          if (this._maxErrorMessage) {
            this.setAttribute('data-max-error-message', this._maxErrorMessage);
          } else {
            this.removeAttribute('data-max-error-message');
          }
        }
      }

      this.setQuantity(this.getQuantity());
    }

    showMaxError() {
      var message =
        this._maxErrorMessage ||
        this.getAttribute('data-max-error-message') ||
        '';
      if (!message) {
        return;
      }

      var toast = window.themeToast || window.ThemeToast;
      if (toast && typeof toast.error === 'function') {
        toast.error(message);
      }
    }

    onDecreaseClick(event) {
      if (event) {
        event.preventDefault();
      }
      this.setQuantity(this.getQuantity() - this._step);
    }

    onIncreaseClick(event) {
      if (event) {
        event.preventDefault();
      }

      if (this._max !== null && this.getQuantity() >= this._max) {
        this.showMaxError();
        this.updateButtonState(this.getQuantity());
        return;
      }

      this.setQuantity(this.getQuantity() + this._step);
    }

    setQuantity(nextQuantity) {
      var quantity = nextQuantity;

      if (quantity < this._min) {
        quantity = this._min;
      }

      if (this._max !== null && quantity > this._max) {
        quantity = this._max;
      }

      if (this._quantityInput instanceof HTMLInputElement) {
        this._quantityInput.value = String(quantity);
      }

      if (this._valueElement instanceof HTMLElement) {
        this._valueElement.textContent = String(quantity);
      }

      this.updateButtonState(quantity);

      this.dispatchEvent(
        new CustomEvent('product:quantity-change', {
          bubbles: true,
          detail: {
            productId: this.getAttribute('data-product-id') || '',
            quantity: quantity,
          },
        })
      );
    }

    updateButtonState(quantity) {
      if (this._decreaseButton instanceof HTMLButtonElement) {
        var disableDecrease = quantity <= this._min;
        this._decreaseButton.disabled = disableDecrease;
        this._decreaseButton.setAttribute(
          'aria-disabled',
          disableDecrease ? 'true' : 'false'
        );
      }

      if (this._increaseButton instanceof HTMLButtonElement) {
        var disableIncrease = this._max !== null && quantity >= this._max;
        this._increaseButton.disabled = disableIncrease;
        this._increaseButton.setAttribute(
          'aria-disabled',
          disableIncrease ? 'true' : 'false'
        );
      }
    }
  }

  customElements.define('quantity-selector', QuantitySelectorElement);
})();
